<template>
  <div class="account-list-item" @click="handleClick">
    <div class="account-info">
      <div class="avatar-container">
        <img v-if="avatarUrl" :src="imageError ? require('@/assets/round1.png') : avatarUrl" :alt="providerName" class="avatar" @error="imageError = true" />
        <div v-if="badgeUrl" class="badge">
          <img :src="badgeUrl" :alt="providerName" class="badge-image" />
        </div>
      </div>

      <div class="account-details">
        <p class="provider-name">{{ providerName }}</p>
        <p class="line-1">{{ line1 }}</p>
        <p v-if="line2" class="line-2">{{ line2 }}</p>
      </div>
    </div>

    <div class="balance-section">
      <div class="label">{{ label }}</div>
      <div class="value">{{ value }}</div>
    </div>
    <div class="arrow-icon">
				<img class="arrow" src="../../assets/arrow-right.png">
		</div>
  </div>
</template>

<script>
export default {
  name: 'AccountListItem',
  props: {
    providerName: {
      type: String,
      required: true,
      description: 'Name of the provider (e.g., "Monzo", "Nationwide", "AXA")'
    },
    line1: {
      type: String,
      required: true,
      description: 'First line of account info (e.g., account type, policy type)'
    },
    line2: {
      type: String,
      required: true,
      description: 'Second line of account info (e.g., masked account number)'
    },
    value: {
      type: String,
      required: true,
      description: 'Formatted balance or date string to display'
    },
    avatarUrl: {
      type: String,
      required: true,
      description: 'URL for the bank avatar/logo image'
    },
    badgeUrl: {
      type: String,
      default: '',
      description: 'Optional URL for a small badge overlay on the avatar'
    },
    label: {
      type: String,
      default: 'Balance',
      description: 'Label for the section (e.g., "Balance", "Renewal")'
    }
  },
  data() {
    return {
      imageError: false
    }
  },
  computed: {
    formattedBalance() {
      return this.formatter.format(this.balance);
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped>
.account-list-item {
  background: white;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.1);
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;
  color: var(--text-color);
}

.account-list-item:hover {
  background-color: #f9f9f9;
}

.account-info {
  flex: 1;
  display: flex;
  gap: 8px;
  align-items: center;
  position: relative;
  min-width: 0;
  overflow: hidden;
}

.avatar-container {
  position: relative;
  flex-shrink: 0;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 0.4px solid #cccccc;
  object-fit: cover;
  object-position: 50% 50%;
  display: block;
}

.badge {
  position: absolute;
  width: 16px;
  height: 16px;
  bottom: 0;
  left: 18px;
  top: 26px;
}

.badge-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.account-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.provider-name {
  font-size: 11px;
  font-weight: bold;
  line-height: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line-1 {
  font-size: 11px;
  line-height: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.line-2 {
  font-size: 11px;
  font-weight: bold;
  line-height: 12px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.balance-section {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 100px;
  flex-shrink: 0;
}

.label {
  font-size: 8px;
  line-height: 0;
  white-space: pre-wrap;
  padding-bottom: 4px;
  text-transform: uppercase;
  margin: 0;
}

.value {
  font-size: 13px;
  line-height: 16px;
}

.arrow-col {
	text-align: right;
	padding-left: 0px;
	padding-top: 15px;
}

.arrow {
	width: 16px;
}

</style>
